import React from "react"
import Layout from "../components/layout"
import { FilingsPiece, type ExitLink } from "@multiagentbook/shared"

/**
 * 404. The same artwork multiagentbook.com uses — one implementation in
 * packages/shared rather than two 404s that drift apart. This page previously
 * showed a centred heading and a single "Go back home" button while the book
 * site had the filings piece.
 *
 * The ways out are this site's, not the book site's: someone who mistyped a
 * URL here is mid-purchase or looking for their downloads, so the exits are
 * the store and the dashboard rather than the book's marketing pages.
 */
const siteMetadata = {
  title: "Designing Multi-Agent Systems",
  description:
    "That page does not exist. Get the digital edition of Designing Multi-Agent Systems: PDF and EPUB with lifetime updates.",
  author: "Victor Dibia",
  image: "/images/og-card.png",
  keywords: "multi-agent systems, ai agents, book",
  twitterUsername: "@designingwithml",
}

const exits: ExitLink[] = [
  { labelKey: "nav.home", label: "Home", href: "/" },
  { labelKey: "nav.buy", label: "Get the book", href: "/checkout" },
  { labelKey: "nav.dashboard", label: "Your downloads", href: "/dashboard" },
  {
    labelKey: "nav.book",
    label: "multiagentbook.com",
    href: "https://multiagentbook.com",
    isExternal: true,
  },
]

const NotFoundPage: React.FC = () => (
  <Layout meta={siteMetadata} title="Page Not Found" link="/404">
    <main className="container mx-auto px-4 py-10 md:py-16">
      <FilingsPiece links={exits} />
    </main>
  </Layout>
)

export default NotFoundPage
